import cx from "classnames";
import Tooltip from "../../../_components/atoms/tooltip";
import IconButton2 from "../../../_components/icon-button-2-component";
import UIcon from "../../../_components/uicon-component";

function SettingPageHeaderComponent({
  pageLabel = "New Page",
  formLabel = "New Form",
  entityName = "Data",
  formHeaderData = "",
  formIconTooltip = "Open Form",
  formIcon = "envelope-plus",
  isFormVisible,
  setIsFormVisible,
  refreshDataList,
}) {
  return (
    <>
      <div
        className={cx(
          "flex flex-col pl-4 pr-2  w-full theme-bg-surface shadow",
          {
            "py-4": isFormVisible,
            "py-2": !isFormVisible,
          }
        )}>
        <div className="w-full flex items-center justify-between">
          <div className="flex items-center justify-between w-full">
            <button
              className={cx("", {
                "cursor-pointer": isFormVisible,
                "cursor-default": !isFormVisible,
              })}
              onClick={(e) => {
                if (isFormVisible) setIsFormVisible(false);
              }}>
              {isFormVisible ? (
                <span className="flex items-center space-x-2">
                  <UIcon icon="angle-left" />
                  <span>{formLabel}</span>
                </span>
              ) : (
                pageLabel
              )}
            </button>
            {isFormVisible ? (
              formHeaderData
            ) : (
              <div className="flex space-x-2">
                <Tooltip label={"Refresh " + entityName}>
                  <IconButton2
                    icon="rotate-right"
                    hoverable
                    onClick={refreshDataList}
                  />
                </Tooltip>
                <Tooltip label={formIconTooltip}>
                  <IconButton2
                    icon={formIcon}
                    hoverable
                    onClick={() => {
                      setIsFormVisible(!isFormVisible);
                    }}
                  />
                </Tooltip>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default SettingPageHeaderComponent;
